export default "__VITE_ASSET__DV0mzNNO__"